import { createAuthClient } from 'better-auth/react';

/**
 * Auth client. Same origin, so no baseURL is needed — in development Vite
 * proxies /api to the API server, and in production the API serves this bundle.
 */
export const authClient = createAuthClient({
  basePath: '/api/auth',
});

// requestPasswordReset, not the older forgetPassword: the client still exposes
// the latter but it posts to /forget-password, which this version of
// better-auth no longer serves - it 404s.
export const { signIn, signOut, useSession, requestPasswordReset, resetPassword } = authClient;
